<mat-form-field appearance=""
                [class.form-slim]="slim">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-select [ngModel]="value"
                [required]="required"
                [disabled]="disabled"
                (ngModelChange)="update($event)"
                (openedChange)="openedChange($event)"
                [placeholder]="placeholder"
                [multiple]="multiple"
                [compareWith]="compareFn"
                [errorStateMatcher]="errorStateMatcher"
                [panelClass]="'sp-select'">

        <div class="select-wrapper">
            <input *ngIf="isSearchEnabled"
                   [(ngModel)]="search"
                   (appDebounce)="filter($event)"
                   (keydown)="$event.stopPropagation()"
                   [placeholder]="'LABEL.SELECT_FILTER' | translate"
                   class="input-filter"
                   #filterInput
                   matInput
                   type="text">

            <div class="select-list-wrapper" #scrollingDiv [class.select-has-search]="isSearchEnabled">
                <mat-option [value]="null"
                            *ngIf="hasEmpty && !multiple">{{ 'LABEL.SELECT_PLACEHOLDER' | translate }}</mat-option>
                <mat-option *ngFor="let option of filteredItemList"
                            [value]="multiple ? {code: option[bindValue]} : (bindValue ? option[bindValue] : option)">
                    <span *ngIf="!optionTemplate">{{ bindDescription ? option[bindDescription] : option }}</span>
                    <span *ngIf="optionTemplate">
            <ng-container *ngTemplateOutlet="optionTemplate; context:{option: option}"></ng-container>
        </span>
                </mat-option>
            </div>
        </div>
    </mat-select>

    <mat-error *ngFor="let error of errors">
        {{ error.description }}
    </mat-error>
</mat-form-field>
